<template>
	<div class="Recharge">
		<el-dialog :visible.sync="DialogShow"  width="700px" :close-on-press-escape='false' :show-close='false' :lock-scroll='false'
		 :close-on-click-modal='false' top='10vh' :before-close="dialogClose2" class='chongzhiDialog'>
			<template #title>
				<div class="dialog_class">
					<div class="left">
						<el-image :src='require("@/assets/recharge/login_tx_2.png")'  style='width: 70px;height: 70px;vertical-align: middle;'></el-image>
					</div>
					<div class="mind">
						<div>
							正在为 {{userInfo.phone2}} 充值
						</div>
						<div style='font-size:20px;margin-top: 12px;'>
							当前游戏剩余时长:&nbsp;  &nbsp;  
							<!-- <el-image :src='require("@/assets/recharge/bukabi@2x.png")' style='width: 25px;height: 25px;vertical-align: text-bottom;'></el-image> -->
							<div style='font-size:26px;display: inline-block;'>
								{{userInfo.tota_time | fitlerTime}}
							</div>
							
						</div>
					</div>
					
				</div>
				<div class="right" >
					<div class="right_div" @click='closeDialog'></div>
				</div>
			</template>
			<el-row style='margin: 26px 0 16px 0;'>
				<div style='text-align: left;'>
					<span style='font-size: 20px;color:rgba(13,13,13,1);padding-left: 10px;'>{{payListTitle}}</span>
				</div>
			</el-row>
			<img v-if="dynamicEffect1 && productFetchList && productFetchList.length!=3 &&productFetchListShow.length==3" @click="change(1,productFetchList)" :src="require('@/assets/recharge/right.png')" alt="" class="right-img" style="top: 236px;">
			<img v-if="dynamicEffect1 && productFetchList && productFetchList.length>3 && productFetchListShow.length<3" @click="change(1,productFetchList)" :src="require('@/assets/recharge/left.png')" alt="" class="left-img" style="top: 236px;">
			<div style="height: 120px;">
				<el-row style='display: flex;flex-wrap: wrap;' v-if="dynamicEffect1">
				
					<el-col v-for='(item,i) in productFetchListShow' :key='i' :span='8' style='margin: 0px 0;cursor: pointer;'>
						<div>
	
							<!-- <el-badge :value="item.corner_mark"> -->
								<div :class="['badgeItem',{'badgeItemActive':choseItem.id==item.id}]" @click='chose(item)'>
									<div class="badge" v-if="item.corner_mark">
										<span>{{item.corner_mark}}</span>
									</div>
									<div style='text-align: center;margin: 20px 0 0 0;'>
										<div style='font-weight: bold;display: inline-block;font-size:18px;color:#0D0D0D;'>
											{{item.describe}}
										</div><br>
										<!-- <el-image :src='require("@/assets/recharge/bukabi@2x.png")' style='width: 25px;height: 25px;vertical-align: text-bottom;'></el-image> -->
										<div style='font-weight: bold;display: inline-block;font-size:26px;color:#FA6400'>
											￥{{item.product_price}}
										</div>
									</div>
									<!-- <div style='text-align: center;margin: 7px 0; font-size:18px;color:rgba(250,100,0,1);'>
										{{item.product_name.indexOf('VIP')!=-1?'送积分+永久VIP':'送积分'}}
									</div> -->
									<div v-if="item.original_price" style='text-align: center;margin: 0px 0; font-size:18px;color:#646464;text-decoration:line-through'>
										{{item.original_price}}元
									</div>
								</div>
							<!-- </el-badge> -->
			
						</div>
					</el-col>
				</el-row>
			</div>

			<el-row style='margin: 26px 0 16px 0;'>
				<div style='text-align: left;'>
					<span style='font-size: 20px;color:rgba(13,13,13,1);padding-left: 10px;'>充值时长</span>
				</div>
			</el-row>
			<img v-if="dynamicEffect2 && ProductsList && ProductsList.length!=3 && productListShow.length==3" @click="change(2,ProductsList)" :src="require('@/assets/recharge/right.png')" alt="" class="right-img" style="top: 423px;">
			<img v-if="dynamicEffect2 && ProductsList && ProductsList.length>3 && productListShow.length<3" @click="change(2,ProductsList)" :src="require('@/assets/recharge/left.png')" alt="" class="left-img" style="top: 423px;">
			<div style="height: 120px;">
				<el-row style='display: flex;flex-wrap: wrap;' v-if="dynamicEffect2">
				
					<el-col v-for='(item,i) in productListShow' :key='i' :span='8' style='margin: 0px 0;cursor: pointer;'>
						<div>
							<!-- <el-badge :value="item.corner_mark"> -->
								<div :class="['badgeItem',{'badgeItemActive':choseItem.id==item.id}]" @click='chose(item)'>

									<div class="badge" v-if="item.corner_mark">
										<span>{{item.corner_mark}}</span>
									</div>

									<div style='text-align: center;margin: 20px 0 0 0;'>
										<div style='font-weight: bold;display: inline-block;font-size:18px;color:#0D0D0D;'>
											{{item.describe}}
										</div><br>
										<!-- <el-image :src='require("@/assets/recharge/bukabi@2x.png")' style='width: 25px;height: 25px;vertical-align: text-bottom;'></el-image> -->
										<div style='font-weight: bold;display: inline-block;font-size:26px;color:#FA6400'>
											￥{{item.product_price}}
										</div>
									</div>
									<!-- <div style='text-align: center;margin: 7px 0; font-size:18px;color:rgba(250,100,0,1);'>
										{{item.product_name.indexOf('VIP')!=-1?'送积分+永久VIP':'送积分'}}
									</div> -->
									<div v-if="item.original_price" style='text-align: center;margin: 0px 0; font-size:18px;color:#646464;text-decoration:line-through'>
										{{item.original_price}}元
									</div>
								</div>
							<!-- </el-badge> -->
			
						</div>
					</el-col>
				</el-row>
			</div>

			<el-row style='margin: 24px 0;' v-show='choseItem.id'>
				<el-col :span='24'>
					<el-tabs tab-position="left" style="height: 150px;width: 100%;" type='border-card' v-model="Paymen" @tab-click='payChange'>
						<el-tab-pane lazy name='alipay'>
							<div slot="label" style='height: 75px; line-height: 75px;text-align: left;font-size: 20px;'>
								<el-image style='width: 20px;height: 20px;vertical-align: middle;' :src="require('@/assets/recharge/alipay@2x.png')"></el-image>
								支付宝支付
							</div>
							<div style="display: flex;margin: 10px 0px 10px 35px;" v-show='Paymen!=""'>
								<div>
									<div class="qrCodeBg">
										<VueQr :margin='5' :size='100' :text='qr_text'></VueQr>
									</div>
								</div>
								<div style='margin-left: 30px;margin-top: 15px;'>
									<div style='color: #858585;font-size: 16px;'>
										使用手机扫一扫
									</div>
									
									<div style='color:#000;font-size:18px;margin-top: 20px;'>
										<span >
											支付金额:
										</span>
										<span style='color: #FA6400;font-size: 25px;'>{{choseItem.product_price}}</span>
										 <span>元</span>
									</div>
								</div>
		
		
							</div>
		
						</el-tab-pane>
						<el-tab-pane lazy name='wxpay' v-if="userInfo.phone=='16666688888'">
							<div slot="label" style='height: 75px; line-height: 75px;text-align: left;font-size: 20px;'>
								<el-image style='width: 20px;height: 20px;vertical-align: middle;' :src="require('@/assets/recharge/wechat@2x.png')"></el-image>
								微信支付
							</div>
							<div style="display: flex;margin: 10px 0px 10px 35px;" v-show='Paymen!=""'>
								<div>
									<div class="qrCodeBg2">
										<VueQr :margin='5' :size='100' :text='qr_text'></VueQr>
									</div>
								</div>
								<div style='margin-left: 30px;margin-top: 15px;'>
									<div style='color: #858585;font-size: 16px;'>
										使用手机扫一扫
									</div>
									
									<div style='color:#000;font-size:18px;margin-top: 20px;'>
										<span >
											支付金额:
										</span>
										<span style='color: #FA6400;font-size: 25px;'>{{choseItem.product_price}}</span>
										 <span>元</span>
									</div>
								</div>
							</div>
						</el-tab-pane>
					</el-tabs>
		
				</el-col>
			</el-row>
		
			<!-- 支付成功时的回调显示 -->
			<el-dialog width="250px" :visible.sync="successShow"  append-to-body :show-close='false' top='40vh' class='successDialog'>
				<div style="text-align: center;">
					<el-image style='width: 60px;height: 60px;vertical-align: middle;' :src="require('@/assets/recharge/chenggong@2x.png')"></el-image>
				</div>
				<div style='color: rgba(13,13,13,1);text-align: center; font-size: 17px;'>
					充值成功
				</div>
				<div style='color:rgba(109,114,120,1);text-align: center;font-size:12px !important;'>
					小主，系统检查你已充值成功。
				</div>
			</el-dialog>
		</el-dialog>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {Row,Col,Tabs,
	TabPane,Badge,Message} from 'element-ui';
	Vue.use(Row).use(Col).use(Tabs)
	.use(TabPane).use(Badge);
	import VueQr from 'vue-qr';
	export default{
		name:'Recharge',
		props:['DialogShow','choseProduct'],
		data(){
			return{
				errMsg:'',
				choseItem:{},
				Paymen:'alipay',
				ProductsList:[],
				productListShow:[],
				productFetchList:[],
				productFetchListShow:[],
				userInfo:JSON.parse(sessionStorage.getItem('userInfo')) || {phone2:''},
				timer:null,
				timerCount:0,
				successShow: false,
				qr_text:'',
				clickNum:0, // 充值按钮点击次数
				clickFetchNum:0, //新手按钮点击次数
				dynamicEffect2:true,
				dynamicEffect1:true,
				payListTitle:"新人礼包",
				first_type:1,
				timeout:'' // 切换定时器
			}
		},
		components:{
			VueQr
		},
		filters:{
			fitlerTime (val) {
				console.log(val)
				return parseInt(val/3600) + "小时" + parseInt(val%3600/60) + "分钟"
			}
		},
		mounted() {
			let that = this;
			console.log(JSON.parse(sessionStorage.getItem('userInfo')))
			that.getLoginInfo()
		},
		methods:{
			change(index,list){
				let that = this
				if(index == 2){
					this.dynamicEffect2 = false 
					setTimeout(()=>{
						that.dynamicEffect2 = true
					},500)
					this.clickNum++
					if(this.clickNum*3 > this.ProductsList.length){
						this.clickNum=0
					}
					let start = this.clickNum==0 ? 0 : this.clickNum*3
					this.productListShow = this.ProductsList.slice(start,start+3)
				}else{
					this.dynamicEffect1 = false 
					setTimeout(()=>{
						that.dynamicEffect1 = true
					},500)
					this.clickFetchNum++
					if(this.clickFetchNum*3 > this.productFetchList.length){
						this.clickFetchNum=0
					}
					let start = this.clickFetchNum==0 ? 0 : this.clickFetchNum*3
					this.productFetchListShow = this.productFetchList.slice(start,start+3)	
				}
			},
			dialogClose2(done) {
				let that = this;
				that.errMsg = '';
				that.choseItem = {};
				that.Paymen = '';
				done();
			},
			closeDialog(){
				let that = this;
				that.$bus.$emit('RechargeDialogShow',false);
			},
			getLoginInfo(){
				let that = this;
				let url = 'api/v1/cloud_pc/app/user_info';
				that.$req.post(url, {})
					.then(res => {
						if (res.data) {
							// that.userInfo=res.data
							let obj = res.data;
							let str = res.data.phone;
							obj.phone2 = str.substr(0,3)+'****'+str.substr(7,str.length);
							obj.surplus_coin = res.data.my_coin - res.data.used_coin + res.data.cy_count;
							obj.tota_time = obj.surplus_coin/5*60
							that.userInfo = obj;
							that.$set(that.userInfo,obj);
							// that.$bus.$emit("getUserInfo",that.userInfo)
							Vue.prototype.GetUserInfo=that.userInfo
							sessionStorage.setItem('userInfo',JSON.stringify(res.data));

							if (that.userInfo.user_type == 1) {
								console.log("新人礼包")
								that.payListTitle="新人礼包";
								that.first_type=1
							} else if (that.userInfo.user_type == 2) {
								console.log("进阶礼包")
								that.payListTitle="进阶礼包";
								that.first_type=15
							} else {
								console.log("畅玩会员套餐")
								that.payListTitle="畅玩会员套餐";
								that.first_type=17
							}
							if (this.DialogShow) {
								that.getFetchProducts();
								that.getProducts();
							}
						}
					})
					.catch(err => {
						console.error(err);
					})
			},
			// 获取充值套餐
			getProducts() {
				let that = this;
				let url = 'api/v1/cloud_pc/app/product/list';
				that.$req.post(url, {
						product_type: 0
					})
					.then(res => {
						if (res.code === 0 && res.data) {
							let arr = res.data;
							that.ProductsList = [...arr];
							that.productListShow = that.ProductsList.slice(0,3)
							// that.chose(that.productListShow[0]);
							// arr.map((k,v)=>{
							// 	if(k.id == 82){
							// 		that.chose(arr[v]);
							// 	}
							// })
						} else {
							Message.error(res.msg);
						}
					})
					.catch(err => {
						console.error(err);
					})
			},
			// 获取充值套餐
			getFetchProducts() {
				let that = this;
				let url = '/api/v1/cloud_pc/app/product/list';
				let data = {
					product_type: 0,
					first_type:that.first_type
				};
				that.$req.post(url, data)
					.then(res => {
						if (res.code === 0 && res.data) {
							let arr = res.data;
							if(that.first_type==1){
								let url = '/api/v1/cloud_pc/app/product_record';
								let data = {
									product_id:197
								};
								that.$req.post(url,data).then(Res=>{
									if(Res.data.status==0){
										that.productFetchList=res.data.filter(item=>item.id!=197)
										that.productFetchListShow = that.productFetchList.slice(0,3)
										that.chose(that.productFetchListShow[0]);
									}else{
										that.productFetchList = [...arr];
										that.productFetchListShow = that.productFetchList.slice(0,3)
										that.chose(that.productFetchListShow[0]);
									}
								}).catch(err=>{

								})
							}else{
								that.productFetchList = [...arr];
								that.productFetchListShow = that.productFetchList.slice(0,3)
								that.chose(that.productFetchListShow[0]);
							}
						} else {
							Message.error(res.msg);
						}
					})
					.catch(err => {
						console.error(err);
					})
			},
			chose(item) {
				let that = this
				that.choseItem = item;
				if(this.timeout !== null)   clearTimeout(this.timeout);        
				this.timeout = setTimeout(()=>{
					that.$utils.Burying({
						act: 'changeProductPrice',
						user_attribute: 'old',
						userID: JSON.parse(localStorage['login']).user_id,
						phone: that.userInfo.phone,
						operating_system: 'web',
						Registration_time: that.userInfo.create_time,
						price:item.product_price
					});
					if (that.choseItem.id) {
						that.getQRcode();
					}
				},1000)
			},
			payChange(val) {
				let that = this;
				that.Paymen = val.name;
				if (that.choseItem.id) {
					that.getQRcode();
				}
			},
			//  更新对应付款码
			getQRcode() {
				let that = this;
				that.qr_text = '';
				that.$utils.Burying({
					act: 'daizhifu',
					user_attribute: 'old',
					userID: JSON.parse(localStorage['login']).user_id,
					phone: that.userInfo.phone,
					operating_system: 'web',
					Registration_time: that.userInfo.create_time,
					Purchase_quantity:1,
					Actual_payment_amount:that.choseItem.product_price
				});
				let url = 'api/v1/cloud_pc/app/pay';
				let data = {
					"terminal": "WEB", // 终端来源 Android/IOS/PC/WEB
					"channel": that.Paymen, //支付渠道  alipay、wxpay、paypal(暂不支付)
					"method": "qr_code", //web(PC 浏览器)、wap（手机浏览器(支付宝))、app(生成支付参数，用于 App 上调用相关的 SDK 使用(支付宝、微信支付))、qr_code(生成收款二维码，供用户扫码进行支付(支付宝、微信支付))、f2f(扫描用户的付款码进行收款)
					"product_id": that.choseItem.id, // 商品id,自定义金额时id为0
				};
				that.$req.post(url, data)
					.then(res => {
						// console.info(res);
						if (res.code === 0 && res.data) {
							that.qr_text = res.data.url;
							// 轮询支付状态
							if (that.timer != null || that.timer) {
								clearInterval(that.timer);
							}
							clearInterval(that.timer);
							that.timer = setInterval(() => {
								that.timerCount++;
								let query = {
									"channel": that.Paymen,
									"trade_no": "",
									"out_trade_no": res.data.order_no
								};
								that.getPayStatus(query);
							}, 3000)
							
						} else {
							Message.error(res.msg);
						}
					})
					.catch(err => {
						console.error(err);
					})
			},
			// 获取支付回调
			getPayStatus(data) {
				let that = this;
			
				let url = 'api/v1/cloud_pc/app/pay/query';
				that.$req.post(url, data)
					.then(res => {
						// console.info(res);
						if (res.code === 0 && res.data) {
							that.$utils.Burying({
								act: 'zhifuSuccess',
								user_attribute: 'old',
								userID: JSON.parse(localStorage['login']).user_id,
								phone: that.userInfo.phone,
								operating_system: 'web',
								Registration_time: that.userInfo.create_time,
								Purchase_quantity:1,
							});
							// 充值成功后 重新获取用户信息
							that.$bus.$emit('getLogin');
							that.successShow = true;
							clearInterval(that.timer);
							that.timer=null;
							setTimeout(()=>{
								// Message.success("充值成功")
								that.successShow = false;
								that.getLoginInfo()
								that.$bus.$emit('RechargeDialogShow',false);
								// that.DialogShow = false;
							},3000)
						}
					})
					.catch(err => {
						console.error(err);
					})
			},
		},
		watch:{
			'DialogShow':function(val){
				let that =  this;
				if(val){
					// if(sessionStorage['userInfo']&&typeof sessionStorage['userInfo'] !='undefined'){
					// 	that.userInfo = JSON.parse(sessionStorage['userInfo']);
					// }else{
					// 	that.getLoginInfo()
					// }
					that.getLoginInfo()
					that.getFetchProducts();
					that.getProducts();
					console.warn(1111111)
				}else{
					that.$utils.Burying({
						act: 'zhifuzhongduan',
						user_attribute: 'old',
						userID: JSON.parse(localStorage['login']).user_id,
						phone: that.userInfo.phone,
						operating_system: 'web',
						Registration_time: that.userInfo.create_time,
						Purchase_quantity:1,
					});
					clearInterval(that.timer)
					that.timer=null
				}
			},
			'choseProduct':function(val){
				// let that = this;
				// if(val&&val!=null){
				// 	that.chose(val);
				// }
			},
			'$route':function(to,from){
				let that  =  this;
				clearInterval(that.timer)
				that.timer=null
			}
		}
	}
</script>

<style lang="less" scoped>
	.chongzhiDialog{
		margin-bottom:0;
		// z-index: 99999999999;
		/deep/
		.el-dialog{
			margin-bottom:0;
		}
		.dialog_class{
			display: flex;
			background: url('../assets/recharge/dialog_bg_big@2x.png') no-repeat center;
			background-size: cover;
			border-radius:22px 22px 0px 0px;
			height: 100px;
			line-height: 100px;
			position: absolute;
			width: 100%;
			z-index: 99;
			.left{
				flex: 0.5;
				margin-left: 30px;
				.el-avatar{
					vertical-align: middle;
				}
				
			}
			.mind{
				flex: 3;
				display: flex;
				flex-direction: column;
				padding-top: 25px;
				padding-bottom: 25px;
				height: 50px;
				line-height: 50px;
				text-align: left;
				div{
					height: 20px;
					line-height: 20px;
					font-size: 16px;
					font-family: MicrosoftYaHei;
					color: rgba(13,13,13,1);
				}
			}
			
		}
		.right{
				width: 55px;
				height: 90px;
				position: relative;
				.right_div{
					background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAB4CAMAAABSMIXEAAAAb1BMVEUAAAD/swDouQD4tgD4tAD4tQD2tAD2tAD2twD3tQD3tQD4tQD3tQD4tgD3tQD4tQD4tQD3tQD4tQD4tQD4tQD2rQD2sAD3tQD3tgX3tgb3uA33vBv50F760WD75KX85qr87cX87sb++u/+/fn///+OC2rxAAAAFXRSTlMACgsjR0hSWFiDhpWosbrQ1+vx9vh7dOKjAAABTUlEQVRo3u3a2a7CIBAGYLf21Lp1UX/FDXXe/xnPhUsoaROpf3I4ycwlIV8IMHAxM0DvWJfFIp8MB17gy6jnCRcEsErJILAck0FUP2QQmLJBzNjga408EBkbrMZkEEs2iJQNrtggEjY4Z4P1iAxiwgZzNrgIAXfn28W4A+ZyO++ac4oQ8Cgi1hGNFZFjc04ZAp6kIRorInLyfq4QcG9d8eHZvTcp6FCMIxor3g70AB2lywsE306nFwo+xeu1ywsGn2KnFw6+xXavB4jDXUTkfgDiXCF7D9mnzL6H7Exh5zL9tfnkPQT7xQb7TwH711NQQQUVVFBBBRVUUMF4wO2mJbZfgJvWiGmFem0U1EzRU1ZQM+VfZ8qaDZZssPjTEtInkcdehquHsZcyk9jLwWnkJXV60T+LvHFiFnfzSZVF3cDDbTEiNkE92rRGXpfWL5RrVDuaKhuBAAAAAElFTkSuQmCC) no-repeat center;
					background-size: cover;
					cursor: pointer;
					width: 80px;
					height: 120px;
					position: absolute;
					margin-left: 669px;
					margin-bottom: 0px;
					margin-top: -2px;
					border-radius: 0px 17px 17px 0px;
					z-index: -1;
				}
				
			}
	}
	

	.badgeItem{
		display: flex;
		flex-direction: column;
		width: 200px;
		height: 120px;
		border-radius:12px;
		border:2px solid rgba(224,224,224,1);
		position: relative;
		animation:scaleBig 0.6s;
		.badge{
			width: auto;
			padding: 3px 16px 3px 16px;
			position: absolute;
			top: -13px;
			right: -8px;
			background: #f9dd4a;
			border-radius: 50px 50px 50px 0px;
		}
	}
	.badgeItemActive{
		background:rgba(255,252,236,1);
		border-color: rgba(249,221,74,1);
	}
	
	// 二维码背景
	.qrCodeBg{
		width: 102px;
		height: 102px;
		background:url(../assets/recharge/smk_alipay@2x.png) no-repeat center;
		background-size: 100% 100%;
		padding: 3px 2px 2px 3px;
	}
	.qrCodeBg2{
		width: 102px;
		height: 102px;
		background:url(../assets/recharge/smk_wechat@2x.png) no-repeat center;
		background-size: 100% 100%;
		padding: 3px 2px 2px 3px;
	}
	.successDialog{
		z-index: 2005 !important;
	}
	/deep/
	.el-badge__content.is-fixed{
		right: 60px ;
		background:rgba(249,221,74,1);
		font-family:MicrosoftYaHei;
		color:rgba(191,76,0,1);
	}
	
	/deep/
	.el-tabs__item{
		height: 75px !important;
		line-height: 75px !important;
	}
	/deep/
	.el-tabs--left.el-tabs--border-card .el-tabs__item.is-left.is-active{
		border-color: transparent !important;
	}
	/deep/
	.el-tabs--border-card{
		border: 2px solid #DCDFE6;
		border-radius: 10px;
	}
	
	.right-img{
		width: 24px;height: 24px;position: absolute;right: 23px;z-index: 999;cursor: pointer;animation:scaleBig .4s;opacity: 0.8;
	}
	.left-img{
		width: 24px;height: 24px;position: absolute;left: 8px;z-index: 999;cursor: pointer;animation:scaleBig .4s;opacity: 0.8;
	}
	// 兼容 IE11
	@media screen and(-ms-high-contrast:active),(-ms-high-contrast:none){
		/deep/
		.el-badge__content{
			font-size: 16px;
		}
	}
	@keyframes scaleBig {
		0%{
			opacity: 0;
			transform: scale(.5);
		}
		100%{
			opacity: 1;
			transform: scale(1);
		}
	}
</style>
